var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rnb",class:[
    _vm.startProjectPop || _vm.awardsPop || _vm.recruitPop || _vm.pdsPop ? 'typeClose white' : '',
    _vm.navigation || _vm.culturePop ? 'typeClose' : '',
    _vm.readyAction ? 'ready-action' : '',
    _vm.$route.meta.themes === 'white' && !_vm.navigation ? 'white' : ''
  ]},[_c('div',{staticClass:"menu"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){$event.preventDefault();return _vm.navigationCall($event)}}})]),_c('menu-area')],1)}
var staticRenderFns = []

export { render, staticRenderFns }